import React from 'react';
import {
    Grid,
    Menu,
    MenuItem
} from "@material-ui/core";
import clsx from 'clsx';
import {
    MyIconButton,
    DisabledButton,
    NextButton
} from "../../../styling/Styles";

// This component is used to render a row below home's table with projects and contains table pagination actions.
const ProjectsTablePagination = (props) => {

    const {
        page,
        setPage,
        data,
        rowsPerPage,
        setRowsPerPage
    } = props;

    // This const contains the maximum number of displayed projects based on selected number rowsPerPage
    
    let maxPages = 1;
    maxPages =
        data.length / rowsPerPage > 1
        && data.length / rowsPerPage > Math.floor(data.length / rowsPerPage)
            ? Math.floor(data.length / rowsPerPage) + 1
            : Math.floor(data.length / rowsPerPage);

    return(
        <Grid
            container
            justifyContent="center"
            direction="row"
            style={{ marginTop: "1vw" }}
        >
            <PreviousButtonComp 
                page={page}
                data={data}
                rowsPerPage={rowsPerPage}
                setPage={setPage}
            />    
            <PageCounter page={page} maxPages={maxPages} />
            <RowsPerPageSelectionDropdown 
                rowsPerPage={rowsPerPage} 
                setRowsPerPage={setRowsPerPage} 
                setPage={setPage}
            />
            &nbsp;
            <NextButtonComp 
                data={data} 
                rowsPerPage={rowsPerPage} 
                setPage={setPage} 
                maxPages={maxPages} 
                page={page}    
            />
        </Grid>
    )
}

// This component renders the previous page button 
const PreviousButtonComp = ({page, data, rowsPerPage, setPage}) => {

    const handlePreviousPage = () => {
        let pages = Math.floor(data.length / rowsPerPage);
        if (data.length / rowsPerPage > pages) {
          pages += 1;
        }
    
        if (page - 1 >= 0) {
          setPage(page - 1);
        }
    };

    return(
        page - 1 >= 0 ? (
            <NextButton onClick={handlePreviousPage}>
                &nbsp; &lt; Previous &nbsp;
            </NextButton>
        ) : 
        (
            <DisabledButton onClick={handlePreviousPage}>
                &nbsp; &lt; Previous &nbsp;
            </DisabledButton>
        )
    )

}

// This component renders the next page button
const NextButtonComp = ({data, rowsPerPage, setPage, maxPages, page}) => {
    
    const handleNextPage = () => {
        let pages = Math.floor(data.length / rowsPerPage);
        if (data.length / rowsPerPage > pages) {
            pages += 1;
        }

        if (page + 2 <= pages) {
            setPage(page + 1);
        }
    };
 
    return(
            page + 1 >= maxPages ? (
                <DisabledButton onClick={handleNextPage}>
                    &nbsp; Next &gt; &nbsp;
                </DisabledButton>
                ) : (
                <NextButton onClick={handleNextPage}>
                    &nbsp; Next &gt; &nbsp;
                </NextButton>
            )
    )
}

// This component renders the current page of total pages 
const PageCounter = ({page, maxPages}) => 
    (
        <div
            className={clsx("paginationBarStyle")}
            style={{ marginLeft: "2vw", marginRight: "2vw" }}
            >
            Page {page + 1} of {maxPages}
        </div>
    )

// This component renders the dropdown button that opens a menu with options for displayed projects-rows per page
const RowsPerPageSelectionDropdown = ({rowsPerPage, setRowsPerPage, setPage}) => {
    
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const rowsPerPageOptions = [2, 5, 10];

    const openMenu = event => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleChangeRowsPerPage = option => {
        setRowsPerPage(option);
        setPage(0);
        setAnchorEl(null);
    };
    
    return(
        <>
            <MyIconButton onClick={openMenu}>
            {rowsPerPage} rows
            </MyIconButton>
            <Menu
            anchorEl={anchorEl}
            keepMounted
            onClose={handleClose}
            open={open}
            elevation={0}
            getContentAnchorEl={null}
            anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            >
            {rowsPerPageOptions.map(option => (
                <MenuItem
                key={option}
                onClick={() => handleChangeRowsPerPage(option)}
                >
                {option}
                </MenuItem>
            ))}
            </Menu>
        </>
    )
} 

export default ProjectsTablePagination;